module.exports = __webpack_public_path__ + "static/media/logos_facebook.358dc3ef.svg";